import styled from "styled-components";

export const StyledReadyTowItDrawBox = styled.div`
  padding: 3.2rem 2.4rem;
  padding-right: 5.5rem;
  background-color: #e7ede1;
  border: 1px solid #355d2c;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2.4rem;
  max-width: 33rem;
  width: 100%;

  .text-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    .heading-text {
      color: #272037;
      font-size: 1.8rem;
    }
    .value-text {
      color: #272037;
      font-size: 2.4rem;
      font-weight: 700;
    }
  }
`;
